import store from '../redux/store';
import { DOMAIN, ORIGIN } from '../shared';
import axios from 'axios';
import { ControlDict, ControlState } from '../redux/controls/models';

// Gets set to the StandardErrorMsg Control dynamically
let STANDARD_ERROR = 'An error occurred';

function select(state: ControlState): ControlDict | null {
  return state.controls ? state.controls : null;
}

function listener(): void{
  const controlDict = select(store.getState().controls);
  if (controlDict && controlDict?.StandardErrorMsg) {
    STANDARD_ERROR = controlDict.StandardErrorMsg.controlText;
    storeSubscription();
  }
}

// unsubscribe from listener, after STANDARD_ERROR is updated dynamically
const storeSubscription = store.subscribe(listener);

const instance = axios.create({
// .. where we make our configurations
  baseURL: ORIGIN + '/' + DOMAIN
});

// TODO remove
console.log('axiosConfig.ts baseURL', ORIGIN + '/' + DOMAIN);

instance.interceptors.response.use(
  response => {
    // Edit response config
    return response;
  }, async(error) => {
    // Try to send meaningful message from server, use STANDARD_ERROR as last resort
    let res: string;

    // Send nothing if request is cancelled
    if (axios.isCancel(error)) {
      return Promise.reject({cancelled: true});
    }
    // 401 == unauthorized
    if (error?.response?.status == 401) {
      res = STANDARD_ERROR;
    } else {
      // TODO remove
      console.log('axios error', error?.response?.data, error?.message);
      if (error?.response?.data instanceof Blob) {
        const text = await error.response.data.text();
        try {
          return Promise.reject(JSON.parse(text));
        } catch {
          res = text;
        }
      } else {
        res = error?.response?.data && typeof error.response.data == 'string' ?
          error.response.data :
          error?.message ?
            error.message :
            STANDARD_ERROR;
      }
    }
    return Promise.reject(res);
  });

export default instance;